import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { FCM } from '@capacitor-community/fcm'
import { Device } from '@capacitor/device'

import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'Like',
  props: {
    uuid: null,
    type: null
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props as {
  uuid: string
  type?: 'artist' | 'speaker' | 'timeslot'
};



const info = (
  ([__temp,__restore] = _withAsyncContext(() => Device.getInfo())),
  __temp = await __temp,
  __restore(),
  __temp
)

const store = useStore()
const isWeb = computed(() => info.platform === 'web')
const show = computed(
  () => (store.config.notifications && !isWeb.value) || process.env.NODE_ENV !== 'production'
)
const isLiked = computed(() => store.getLikeByUuid(props.uuid))
const toggleLike = async () => {
  if (isLiked.value) {
    store.likes = store.likes.filter((like) => like.uuid !== props.uuid)
    !isWeb.value && (await FCM.unsubscribeFrom({ topic: props.uuid }))
  } else {
    store.likes.push({ uuid: props.uuid, type: props.type })
  }
  !isWeb.value && (await FCM.subscribeTo({ topic: props.uuid }))
}

return (_ctx: any,_cache: any) => {
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_IonButton = _resolveComponent("IonButton")!

  return (_unref(show))
    ? (_openBlock(), _createBlock(_component_IonButton, {
        key: 0,
        fill: "clear",
        color: _unref(isLiked) ? 'secondary' : 'medium',
        onClick: toggleLike
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IonIcon, {
            class: "icon",
            src: "/assets/icon/like.svg"
          })
        ]),
        _: 1
      }, 8, ["color"]))
    : _createCommentVNode("", true)
}
}

})